<script>
export default {
  computed: {
    windowWidth: function () {
      if (window.innerWidth <= 768) return 768
      else if (window.innerWidth > 768 && window.innerWidth <= 1024) return 1024
      else if (window.innerWidth > 1024 && window.innerWidth <= 1280) return 1280
      else if (window.innerWidth > 1280 && window.innerWidth <= 1366) return 1366
      else return 1920
    }
  }
}
</script>
